import React, { useState, useEffect } from "react";
import "react-sweet-progress/lib/style.css";
import NoImageIcon from "../../images/no-image-icon.png";
import phone from "../../images/phone.svg";
import moment from "moment";
import { useMutation, useQuery } from "@apollo/client";
import { END_DEAL } from "../../mutation/endDeal";
import { hasuraClient } from "../../apolloClient";
import { Spinner } from "react-bootstrap";
import Arrow from "../../images/Arrow-Right.svg";
import { Link, useParams, useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import { GET_DEAL_BY_ID } from "../../query/getDealById";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import MainContainer from "../../container/MainContainer";

const DealsDetails = () => {
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const params = useParams();

  const [generalInfo, setGeneralInfo] = useState(null);
  const [expirationData, setExpirationData] = useState(null);
  const [endDeal] = useMutation(END_DEAL, {
    client: hasuraClient,
  });

  const { data } = useQuery(VIEW_PROFILE, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    client: hasuraClient,
  });

  const [
    getDealById,
    { data: dealsData, loading: dealsLoading, error: dealsError },
  ] = useLazyQuery(GET_DEAL_BY_ID, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  let getWeek = {
    0: "SUNDAY",
    1: "MONDAY",
    2: "TUESDAY",
    3: "WEDNESDAY",
    4: "THURSDAY",
    5: "FRIDAY",
    6: "SATURDAY",
  };

  const handleEnd = () => {
    setLoading(true);
    endDeal({
      variables: {
        id: params.id,
      },
    })
      .then(() => {
        setLoading(false);
        history.push("/deals");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (params.id) {
      getDealById({
        variables: {
          id: params.id,
        },
      });
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!dealsLoading && dealsData && !dealsError) {
      let obj = {
        dealName: dealsData.deals_by_pk.name,
        desc: dealsData.deals_by_pk.description,
        condition: dealsData.deals_by_pk.condition,
        dealType: dealsData.deals_by_pk.type,
        uploadedImg: dealsData.deals_by_pk.image_url,
        imagePath: dealsData.deals_by_pk.image_path,
      };

      setGeneralInfo(obj);

      let obj2 = {
        date: new Date(dealsData.deals_by_pk.expire_date_time),
        time: new Date(dealsData.deals_by_pk.expire_date_time),
      };

      setExpirationData(obj2);
    }
  }, [dealsLoading, dealsData, dealsError]);
  return (
    <MainContainer active="deals">
      <>
        {!dealsLoading && dealsData && generalInfo && expirationData ? (
          <section className="event-free-block deals-block">
            <div className="event-free-header">
              <div className="event-col-left back-button">
                <Link to="/deals">
                  <img src={Arrow} alt="arrow right" />
                </Link>
                <h3> {generalInfo.dealName}</h3>
              </div>

              <div className="event-col-right submit">
                <div className="edit-deal">
                  <a
                    href="javascript:void(0)"
                    className="secondary-button"
                    onClick={() => {
                      history.push(`/editdeal/${params.id}`);
                    }}
                  >
                    Edit Deal
                  </a>
                </div>
                <div className="edit-deal">
                  <a
                    href="javascript:void(0)"
                    className="submit-btn primary-button"
                    onClick={() => {
                      handleEnd();
                    }}
                  >
                    {loading ? (
                      <Spinner
                        className="spinner"
                        animation="border"
                        role="status"
                        style={{ height: "20px", width: "20px" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : (
                      "End Deal"
                    )}
                  </a>
                </div>
              </div>
            </div>

            <div className="event-full-image">
              <div className="image">
                {generalInfo.uploadedImg ? (
                  <img src={generalInfo.uploadedImg} alt="image" />
                ) : (
                  <img src={NoImageIcon} alt="image" />
                )}
              </div>
              <p>
                EXPIRES ON {getWeek[new Date(expirationData.date).getDay()]},
                {moment(expirationData.date).format("DD MMM")} at{" "}
                {moment(expirationData.time).format("h:mm a")}
              </p>
            </div>

            <div
              className="event-free-details"
              style={{ justifyContent: "space-between" }}
            >
              <div className="event-col-71">
                <div className="event-details">
                  <h2>Description</h2>
                  <p>{generalInfo.desc} </p>
                  <h2>Conditions</h2>
                  <p>{generalInfo.condition} </p>
                </div>
              </div>
              <div className="event-col-29" style={{ paddingRight: "0px" }}>
                <div className="main-title">
                  <h2>Details</h2>
                </div>
                <div className="event-name">
                  <div className="event-image">
                    {data?.users.length > 0 &&
                    data?.users[0]?.business_profile?.business_profile_photo ? (
                      <img
                        src={
                          data?.users[0]?.business_profile
                            ?.business_profile_photo
                        }
                        alt="business_profile"
                      />
                    ) : (
                      <div className="image-bg"></div>
                    )}
                  </div>
                  <div className="content">
                    <h3>{data?.users[0]?.business_profile?.name}</h3>
                  </div>
                </div>

                <div className="event-location-row">
                  <ul>
                    <li>
                      <div className="event-location-block">
                        <div className="icon">
                          <img src={phone} alt="clock icon" />
                        </div>
                        <div
                          className="location-content"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <h3 style={{ marginBottom: "0px" }}>
                            {" "}
                            {data &&
                              data?.users[0] &&
                              (data?.users[0]?.business_profile
                                ?.mobile_number ? (
                                <a
                                  href={`tel:${data?.users[0]?.business_profile?.mobile_number}`}
                                  style={{ color: "#161f3d" }}
                                >
                                  {
                                    data?.users[0]?.business_profile
                                      ?.mobile_number
                                  }
                                </a>
                              ) : (
                                " - "
                              ))}
                          </h3>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="event-location-block"
                        style={{ fontWeight: "500", lineHeight: "20px" }}
                      >
                        {data &&
                        data?.users[0] &&
                        data?.users[0]?.business_profile?.website ? (
                          <Link
                            to={{
                              pathname:
                                data?.users[0]?.business_profile?.website,
                            }}
                            target="_blank"
                            style={{ display: "block", width: "100%" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                backgroundColor: "#fff",
                                padding: "8px 15px",
                              }}
                            >
                              Website
                            </div>
                          </Link>
                        ) : (
                          <a
                            href="javascript:void(0)"
                            style={{ display: "block", width: "100%" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                backgroundColor: "#fff",
                                padding: "8px 15px",
                              }}
                            >
                              Website
                            </div>
                          </a>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        ) : dealsLoading ? (
          <div className="spinner-cover">
            <Spinner className="spinner" animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : dealsError ? (
          "some error occurred..."
        ) : (
          ""
        )}

        {/* <section className="ticket-section deals-ticket">
        <div className="ticket-sales-main">
          <div className="ticket-sales-cover">
            <div className="main-title">
              <h2>Deals Performance</h2>
            </div>
            <div className="ticket-row">
              <div className="ticket-col-50">
                <div className="deals-performance-chart"></div>
              </div>
              <div className="ticket-col-50">
                <div className="sales-right-row">
                  <ul className="performance-list">
                    <li>
                      <p>
                        Deal claimed <span>300</span>
                      </p>
                    </li>
                    <li>
                      <p>
                        Deal view <span>1200</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shares-event-row">
          <div className="main-title">
            <h2>Deals Claimed</h2>
          </div>
          <div className="share-event-chart-block">
            <div className="datepicker-row">
              <DatePicker
                selected={date}
                dropdownMode="select"
                autoComplete="off"
                onChange={(value) => {
                  setDate(value);
                }}
                className="react-time-input"
                calendarClassName="react-time-picker"
                popperClassName="react-time-propper"
              />
            </div>
            <div className="bar-chart-row">
              <DealsClaimedchart />
            </div>
            <div className="bar-bottom">
              <div className="bar-left">
                <p>Total Claimed</p>
              </div>
              <div className="bar-right">
                <p>
                  10.0%<span>300</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      </>
    </MainContainer>
  );
};

export default DealsDetails;
